import axios from 'axios';
import { API_BASE_URL } from '../config';

// Create a separate API instance for supplier authentication
// This avoids conflicts with the main auth system interceptors
const supplierApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
});

// Add supplier token to requests if available
supplierApi.interceptors.request.use(config => {
  const supplierToken = localStorage.getItem('supplier_token');
  if (supplierToken) {
    config.headers.Authorization = `Bearer ${supplierToken}`;
  }
  
  // Ensure all requests include /api/ prefix
  if (config.url && !config.url.startsWith('/api/') && !config.url.startsWith('http')) {
    config.url = '/api' + config.url;
  }
 
  return config;
});

// Handle supplier-specific responses
// Don't redirect on 401 - let the supplier auth context handle it
supplierApi.interceptors.response.use(
  response => response,
  error => {
    // For supplier API, we don't want automatic redirects
    // Let the supplier auth context handle the errors
    return Promise.reject(error);
  }
);

export default supplierApi;
